import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ConfigService } from './config.service';
import { ShiftBlock } from '../models/shift-block.model';
import { StaffingGridValue } from '../models/staffing-grid-value.model';

@Injectable()
export class StaffingGridService {
    readonly apiServer: string;

    constructor(private _configService: ConfigService, private _http: HttpClient) { 
        this.apiServer = this._configService.appSettings.webApiServer + "api/StaffingGrid/";
    }

    async recoverStaffingGrid(costCenterId: number, isWeekday: boolean, isWeekend: boolean): Promise<ShiftBlock[]> {
        const params = new HttpParams()
                        .set('costCenterId', costCenterId.toString())
                        .set('isWeekday', isWeekday.toString())
                        .set('isWeekend', isWeekend.toString());

        return await this._http.get<ShiftBlock[]>(`${this.apiServer}RecoverStaffingGrid`, { params: params }).toPromise<ShiftBlock[]>();        
    }

    async removeStaffingGrid(costCenterId: number): Promise<boolean> {
        const params = new HttpParams()
            .set('Id', costCenterId.toString());

        return await this._http.delete<boolean>(`${this.apiServer}RemoveStaffingGrid`, { params: params }).toPromise<boolean>();
    }

    async setStaffingGrid(staffingGrid: StaffingGridValue[]) {
        return await this._http.post<number>(`${this.apiServer}SetStaffingGrid`, JSON.stringify(staffingGrid)).toPromise<number>();
    }    
}